<template>
  <div class="container px-0">
    <h3>{{ $t('Meta data') }}</h3>
    <div class="row">
      <div class="col-md-4 col-xs-12 metaKey"
           v-text="$t('Key')"
      ></div>
      <div class="col-md-6 col-xs-12 metaValue"
           v-text="$t('Value')"
      ></div>
    </div>
    <hr style="margin-top:1rem; margin-bottom:1rem"/>
    <div class="row">
      <template v-for="metaItem in value">
        <div class="col-md-4 col-xs-12 metaKey"
             v-text="metaItem.key"
        ></div>
        <div class="col-md-6 col-xs-12 metaValue"
             v-text="metaItem.value"
        ></div>
      </template>
    </div>
    <br/>
    <div class="row">
    <div class="col-md-4 col-xs-12">
      <base-input
        type="input"
        :name="$t('Key')"
        :placeholder="$t('Meta Key')"
        v-model="model.key"
      >
      </base-input>
    </div>
    <div class="col-md-6 col-xs-12">
      <base-input
        type="input"
        :name="$t('Value')"
        :placeholder="$t('Meta Value')"
        v-model="model.value"
      >
      </base-input>
    </div>
    <div class="col-md-2 col-xs-12">
      <base-button
        v-text="$t('Add')"
        type="info"
        outline
        @click="updateMeta"
      >
      </base-button>
    </div>
  </div>
  </div>
</template>

<script>

  export default {
    name: "MetaInput",
    props: {
      value: []
    },
    data() {
      return {
        model: {
          key: "",
          value: ""
        }
      }
    },
    methods: {
      updateMeta() {
        if (!this.model.key && !this.model.value) return;
        this.onChange([...this.value, {...this.model}])
        this.model = {
          key: "",
          value: ""
        }
      },
      onChange(newValue) {
        this.$emit('input', newValue);
      }
    }
  }
</script>
<style lang="scss">
  .metaKey {
    font-weight: bold;
    font-size: 16px;
  }
  .metaValue {
    font-weight: 300;
    font-size: 16px;
  }
</style>
